import { gql, useMutation } from '@apollo/client';
import { WorkforceUnitEnum } from '../../enums/WorkforceUnitEnum';
import { useGlobalContext } from '../../global-context/GlobalContext';
import { toLocalDate } from '../../utils/calendarUtility';

const ADD_STAFFING_STATUS = gql`
  mutation AddCompanyStaffingStatus($params: AddCompanyStaffingStatusArgs!) {
    addCompanyStaffingStatus(companyStaffingStatusesArgs: $params) {
      message
      status
      statusCode
      error
      data {
        isCreated
      }
    }
  }
`;

export const useAddStaffingStatus = () => {
  const [addStaffingStatus, { error, data, loading }] =
    useMutation(ADD_STAFFING_STATUS);

  const companyId = useGlobalContext(c => c.auth.companyInfo?.companyId);

  const addStatus = (
    status: string,
    reason: string,
    startDate: Date,
    endDate: Date,
    workforce: number,
    workforceUnit: WorkforceUnitEnum,
    onCompleteCb?: (data: any) => any,
  ) => {
    const params = {
      status: status,
      reason: reason,
      startDate: toLocalDate(startDate),
      endDate: toLocalDate(endDate),
      workforce,
      workforceUnit,
    };

    addStaffingStatus({
      variables: {
        params,
      },
      onCompleted: onCompleteCb,
    });
  };

  return { addStatus, error, data, loading };
};
